import graphql__03953bd8fc3974c29c8b from "./__generated__/PageSectionParticipativeModulesList_pageSection.graphql.js";import { createFragmentContainer } from "react-relay";
import { graphql } from "react-relay";

import ParticipativeModuleCard from "../ParticipativeModule/ParticipativeModuleCard";
import PageSectionBlockWithTitleAndDescription from "./PageSectionBlockWithTitleAndDescription";
import ContainerWithSidebar from "../Sidebar/ContainerWithSidebar";

const PageSectionParticipativeModulesList = props => {
  const {
    title,
    description,
    iconClass,
    participativeModules,
    columnsRatio,
    columnsOrder,
    sidebar
  } = props.pageSection;

  return (
    <div className="container page-section page-section-participative-modules-list">
      <ContainerWithSidebar {...{ sidebar, columnsRatio, columnsOrder }}>
        <PageSectionBlockWithTitleAndDescription
          title={title}
          description={description}
          iconClassName={iconClass}
        >
          <div className="row cards-row">
            {participativeModules.map(participativeModule => (
              <div key={participativeModule.id} className="col-md-6">
                <ParticipativeModuleCard participativeModule={participativeModule} />
              </div>
            ))}
          </div>
        </PageSectionBlockWithTitleAndDescription>
      </ContainerWithSidebar>
    </div>
  );
};

export default createFragmentContainer(PageSectionParticipativeModulesList, {
  pageSection: graphql__03953bd8fc3974c29c8b
});
